import CompanyDetail, {
    getServerSideProps as gSSP,
} from '@oberoninternal/travelbase-website/dist/components/pages/CompanyDetail';
import { GetServerSideProps } from 'next';
import addGlobalQuery from '../../utils/addGlobalQuery';

export default CompanyDetail;

export const getServerSideProps: GetServerSideProps = async context => {
    const result = await gSSP(context);
    return addGlobalQuery(result, context.locale);
};
